"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editRiskBlacklist = editRiskBlacklist;
exports.importRiskBlacklist = importRiskBlacklist;
exports.queryRiskBlacklistPaged = queryRiskBlacklistPaged;
exports.queryRiskBlacklistTenantMember = queryRiskBlacklistTenantMember;
exports.queryRiskBlacklistTenantPaged = queryRiskBlacklistTenantPaged;
exports.removeRiskBlacklist = removeRiskBlacklist;
exports.saveRiskBlacklist = saveRiskBlacklist;
exports.saveRiskBlacklistTenant = saveRiskBlacklistTenant;
exports.updateRiskBlacklistTenant = updateRiskBlacklistTenant;
var _request = _interopRequireDefault(require("@/utils/request"));
// 风控黑名单超级查询分页列表
function queryRiskBlacklistPaged(params) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/super/query/paged',
    method: 'get',
    params: params
  });
}

// 风控黑名单租户查询分页列表（仅查询当前租户下的黑名单）
function queryRiskBlacklistTenantPaged(params) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/tenant/query/paged',
    method: 'get',
    params: params
  });
}

// 新增风控黑名单
function saveRiskBlacklist(data) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/super/save',
    method: 'post',
    data: data
  });
}

// 编辑风控黑名单
function editRiskBlacklist(data) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/super/edit',
    method: 'post',
    data: data
  });
}

// 解除风控黑名单
function removeRiskBlacklist(data) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/super/remove',
    method: 'post',
    data: data
  });
}

// 搜索风控用户
function queryRiskBlacklistTenantMember(params) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/tenant/member/query',
    method: 'get',
    params: params
  });
}

// 新增风控黑名单（租户维度）
function saveRiskBlacklistTenant(data) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/tenant/save',
    method: 'post',
    data: data
  });
}

// 解除风控黑名单（租户维度）
function updateRiskBlacklistTenant(data) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/tenant/update',
    method: 'post',
    data: data
  });
}

// 批量导入风控黑名单
function importRiskBlacklist(data) {
  return (0, _request.default)({
    url: '/portal/system/risk/blacklist/super/import',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}